export type SeoNewsArticleOptions = {
  headline: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: string;
};

export type newsArticleLDJson = {
  '@context': 'https://schema.org';
  '@type': 'NewsArticle';
  headline: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author?: {
    '@type': 'Person';
    name: string;
  };
};

export type SeoRelevantContentByTagsOptions = {
  searchTags: Array<string>;
  pinnedArticlePaths: Array<string>;
};
